import { ElementRef, Inject, Injectable, NgZone, OnDestroy, Optional } from '@angular/core';
import { CdkScrollable, ScrollDispatcher } from '@angular/cdk/overlay';
import { Platform } from '@angular/cdk/platform';
import { DOCUMENT } from '@angular/common';

@Injectable({ providedIn: 'root' })
export class CustomScrollDispatcherService extends ScrollDispatcher implements OnDestroy {
  private readonly scrollables: Map<HTMLElement, CdkScrollable> = new Map();

  constructor(
    ngZone: NgZone,
    platform: Platform,
    @Optional() @Inject(DOCUMENT) document: Document,
  ) {
    super(ngZone, platform, document as unknown as any);
    this.registerAllScrollsAsScrollables(document, ngZone);
  }

  private registerAllScrollsAsScrollables(document: Document, ngZone: NgZone): void {
    document.addEventListener(
      'scroll',
      (event: Event) => {
        const target = event.target as EventTarget | null;
        if (target instanceof HTMLElement) {
          if (!this.scrollables.has(target)) {
            this.cleanScrollables();
            const scrollable = new CdkScrollable(new ElementRef(target), this, ngZone);
            this.scrollables.set(target, scrollable);
            this.register(scrollable);
          }
        }
      },
      true,
    );
  }

  private cleanScrollables(): void {
    for (const [element, scrollable] of this.scrollables) {
      if (!element.isConnected) {
        this.scrollables.delete(element);
        this.deregister(scrollable);
      }
    }
  }

  override ngOnDestroy(): void {
    super.ngOnDestroy();
    this.scrollables.clear();
  }
}
